import React from 'react';
import MELogoImageOld from '../../images/me-feedback/me-new-3.jpg';
import MELogoImageNew from '../../images/me-feedback/me-atualizado-com-fundo.jpeg';

const MELogoImages = {
    old: MELogoImageOld,
    new: MELogoImageNew,
};

const MELogo = props => (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
            src={props.src && props.src.length > 0 ? props.src : MELogoImages.new}
            style={props.style != null ? props.style : {  }}
            title="FeedbackLogo"
            className='App-ME-Logo' />
    </div>
);

export default MELogo;
